// frontend/src/admin/components/AdminRoute.js - PROTECTION ROUTES ADMIN
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../../services/api'; // ⬅️ IMPORTANT : on utilise le client Axios

const AdminRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        console.log('🛡️ AdminRoute: vérification des privilèges admin...');

        const token = localStorage.getItem('token');
        const storedUser = localStorage.getItem('user');

        // Si pas de token ou pas d'utilisateur → on ne peut pas être admin
        if (!token || !storedUser) {
          console.log('❌ AdminRoute: pas de token ou pas de user en localStorage');
          setLoading(false);
          setIsAdmin(false);
          return;
        }

        // Vérifier le rôle depuis le localStorage
        const userData = JSON.parse(storedUser);
        const localRole = userData.role;
        console.log('👤 AdminRoute: rôle localStorage =', localRole);

        if (localRole !== 'admin' && localRole !== 'super_admin') {
          console.log('❌ AdminRoute: rôle insuffisant côté client:', localRole);
          setIsAdmin(false);
          setLoading(false);
          return;
        }

        // Vérifier que le token + rôle sont encore valides côté serveur
        console.log('📡 AdminRoute: appel /auth/profile via API client...');
        const response = await api.get('/auth/profile');

        // /auth/profile renvoie { success: true, user: {...} }
        const serverUser = response.data.user || response.data;
        const serverRole = serverUser.role;

        console.log('👤 AdminRoute: user serveur =', serverUser);
        console.log('🎭 AdminRoute: rôle serveur =', serverRole);

        if (serverRole === 'admin' || serverRole === 'super_admin') {
          console.log('✅ AdminRoute: accès admin autorisé');
          setUser(serverUser);
          setIsAdmin(true);
        } else {
          console.log('❌ AdminRoute: rôle insuffisant côté serveur:', serverRole);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('❌ AdminRoute: erreur vérification admin:', error);
        // En cas d'erreur réseau ou 401, l’intercepteur Axios se charge déjà 
        // de gérer la déconnexion si besoin
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminAuth();
  }, []);

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-container">
          <div className="admin-loading-spinner"></div>
          <h2>🛡️ Vérification des privilèges administrateur...</h2>
          <p>Contrôle des autorisations en cours</p>
        </div>
        <style>{`
          .admin-loading {
            min-height: 100vh;
            background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
          }
          
          .admin-loading-container {
            text-align: center;
            padding: 2rem;
          }
          
          .admin-loading-spinner {
            width: 3rem;
            height: 3rem;
            border: 4px solid rgba(255, 107, 53, 0.3);
            border-top: 4px solid #ff6b35;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin: 0 auto 1.5rem;
          }
          
          .admin-loading h2 {
            font-size: 1.5rem;
            margin-bottom: 0.5rem;
            font-weight: 600;
          }
          
          .admin-loading p {
            color: rgba(255, 255, 255, 0.7);
            font-size: 1rem;
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Rediriger vers login si pas de token
  if (!localStorage.getItem('token')) {
    console.log('🔄 AdminRoute: redirection login (aucun token)');
    return <Navigate to="/login" replace />;
  }

  // Rediriger vers dashboard utilisateur si pas admin
  if (!isAdmin) {
    console.log('🔄 AdminRoute: redirection dashboard (accès admin refusé)');
    return <Navigate to="/dashboard" replace />;
  }

  // Ajouter les données admin au composant enfant
  return React.cloneElement(children, { adminUser: user });
};

export default AdminRoute;
